import { AgreementParty, PARTY_ROLE_LABEL, PartyRole } from '../collectionAgreementModel';

const formatDocument = (document: string): string => {
    if (document.length === 11) return `${document.slice(0, 3)}.${document.slice(3, 6)}.${document.slice(6, 9)}-${document.slice(9)}`;
    if (document.length === 14) return `${document.slice(0, 2)}.${document.slice(2, 5)}.${document.slice(5, 8)}/${document.slice(8, 12)}-${document.slice(12)}`;
    return document;
};

const PartyGroup = ({ role, parties }: { role: PartyRole; parties: AgreementParty[] }) => (
    <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">
            {role === 'ASSIGNOR' ? 'Cedentes' : 'Avalistas'} · {parties.length}
        </p>
        {parties.length === 0
            ? <p className="mt-1 text-sm text-gray-500">Nenhum {PARTY_ROLE_LABEL[role].toLowerCase()} na operação</p>
            : (
                <ul className="mt-1 space-y-1">
                    {parties.map(party => (
                        <li key={`${party.role}-${party.documentNumber}`} className="text-sm text-gray-800 dark:text-gray-100">
                            {party.fullName} <span className="font-mono text-xs text-gray-500">{formatDocument(party.documentNumber)}</span>
                        </li>
                    ))}
                </ul>
            )}
    </div>
);

const AgreementPartiesSummary = ({ parties }: { parties: AgreementParty[] }) => (
    <div className="grid grid-cols-1 gap-4 rounded-lg bg-slate-50 px-4 py-3 dark:bg-slate-800/60 md:grid-cols-2">
        <PartyGroup role="ASSIGNOR" parties={parties.filter(party => party.role === 'ASSIGNOR')} />
        <PartyGroup role="GUARANTOR" parties={parties.filter(party => party.role === 'GUARANTOR')} />
    </div>
);

export default AgreementPartiesSummary;
